import { InputAdornment } from '@material-ui/core'
import { AttachMoney } from '@material-ui/icons'
import InputButton from 'Components/UI/Organisms/Plant/Stock/PaperDevolution/DialogDevolution/InputButton'
import { SUCURSAL_ORIGEN } from 'Constants'

export const Fields = (
  info,
  handleSubmitCode,
  handleChange,
  isLoading,
  data,
  dataInfo,
  permissions
) => {
  const opciones = [
    { value: 'STOCK', disabled: [7].includes(dataInfo.infoMain.comprobante) ? true : false },
    { value: 'MANUAL', disabled: !permissions.allowManual ? true : false },
    {
      value: 'RESTO VENTA',
      disabled:
        dataInfo.infoMain.origen !== 'DOS' || [7].includes(dataInfo.infoMain.comprobante)
          ? true
          : false,
    },
    { value: 'BONIFICACION', disabled: [7].includes(dataInfo.infoMain.comprobante) ? true : false },
    { value: 'RECARGO' },
    { value: 'ENVIO' },
  ]

  const opcionesHabilitadas = opciones.filter((opcion) => !opcion.disabled)

  const tarjetasFiltradas =
    info.medio_pago === 'TARJETA DÉBITO'
      ? data.tarjetas.filter((tarjeta) => tarjeta.tipo === 1)
      : info.medio_pago === 'TARJETA CRÉDITO'
        ? data.tarjetas.filter((tarjeta) => tarjeta.tipo === 2)
        : []

  return [
    {
      label: 'Tipo de producto',
      name: 'tipo',
      sm: 12,
      xs: 12,
      options: opcionesHabilitadas,
      optionLabel: `options["value"]`,
      optionValue: 'value',
      value: info.tipo,
      class: 'autocomplete',
      onChange: (e) => handleChange('tipo', e.value),
    },
    ...(info.tipo === 'STOCK'
      ? [
          {
            label: 'Orden comprobante',
            name: 'orden',
            sm: 12,
            xs: 12,
            class: 'textfield',
            type: 'number',
            value: Math.max(0, parseInt(info.orden) || 1),
            onChange: (e) => handleChange('orden', e.target.value),
          },
          {
            class: 'custom',
            name: 'codigo',
            sm: 12,
            xs: 12,
            component: (
              <InputButton
                placeholder="Código"
                name="codigo"
                onSubmit={() => handleSubmitCode(info)}
                onKeyUp={(e) => handleChange('codigo', e.target.value)}
                value={info.codigo}
                resetFormDisabled
                loading={isLoading}
              />
            ),
          },
          {
            label: 'Precio',
            name: 'subiva',
            sm: 12,
            xs: 12,
            class: 'textfield',
            type: 'number',
            value: Math.max(0, parseFloat(info.subiva)),
            inputProps: {
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoney />
                </InputAdornment>
              ),
            },
            onChange: (e) => handleChange('subiva', e.target.value),
          },
          {
            label: 'Observación',
            name: 'observacion',
            value: info.observacion,
            sm: 12,
            xs: 12,
            multiline: true,
            rows: 2,
            class: 'textfield',
            onChange: (e) => handleChange('observacion', e.target.value),
          },
        ]
      : info.tipo === 'MANUAL'
        ? [
            {
              label: 'Orden comprobante',
              name: 'orden',
              sm: 12,
              xs: 12,
              class: 'textfield',
              value: Math.max(0, parseInt(info.orden) || 1),
              type: 'number',
              onChange: (e) => handleChange('orden', e.target.value),
            },
            {
              label: 'Descripción',
              name: 'descripcion',
              sm: 12,
              xs: 12,
              class: 'textfield',
              value: info.descripcion,
              onChange: (e) => handleChange('descripcion', e.target.value),
            },
            {
              label: 'Nº de V',
              name: 'nrodev',
              sm: 12,
              xs: 12,
              class: 'textfield',
              value: info.nrodev,
              onChange: (e) => handleChange('nrodev', e.target.value),
            },
            {
              label: 'Cantidad',
              name: 'cantidad',
              sm: 12,
              xs: 12,
              class: 'textfield',
              value: Math.max(0, parseInt(info.cantidad) || 1),
              type: 'number',
              onChange: (e) => handleChange('cantidad', e.target.value),
            },
            {
              label: 'Precio',
              name: 'subiva',
              sm: 12,
              xs: 12,
              class: 'textfield',
              value: Math.max(0, parseFloat(info.subiva)),
              type: 'number',
              inputProps: {
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachMoney />
                  </InputAdornment>
                ),
              },
              onChange: (e) => handleChange('subiva', e.target.value),
            },
            {
              label: 'Observación',
              name: 'observacion',
              value: info.observacion,
              sm: 12,
              xs: 12,
              class: 'textfield',
              multiline: true,
              rows: 2,
              onChange: (e) => handleChange('observacion', e.target.value),
            },
          ]
        : info.tipo === 'ENVIO'
          ? [
              {
                label: 'Orden comprobante',
                name: 'orden',
                sm: 12,
                xs: 12,
                class: 'textfield',
                value: Math.max(0, parseInt(info.orden) || 1),
                type: 'number',
                onChange: (e) => handleChange('orden', e.target.value),
              },
              {
                class: 'autocomplete',
                sm: 12,
                xs: 12,
                name: 'transporte',
                label: 'Transporte',
                optionValue: 'id',
                options: data.transporte_retiro,
                optionLabel: `options["nombre"]`,
                value: info.transporte,
                onChange: (e) => handleChange('transporte', e.id),
              },
              {
                label: 'Monto',
                name: 'subiva',
                sm: 12,
                xs: 12,
                class: 'textfield',
                type: 'number',
                value: Math.max(0, parseFloat(info.subiva)),
                inputProps: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <AttachMoney />
                    </InputAdornment>
                  ),
                },
                onChange: (e) => handleChange('subiva', e.target.value),
              },
              {
                label: 'Observación',
                name: 'observacion',
                value: info.observacion,
                sm: 12,
                xs: 12,
                class: 'textfield',
                multiline: true,
                rows: 2,
                onChange: (e) => handleChange('observacion', e.target.value),
              },
            ]
          : info.tipo === 'RESTO VENTA'
            ? [
                {
                  label: 'Origen',
                  name: 'empresa',
                  sm: 12,
                  xs: 12,
                  options: SUCURSAL_ORIGEN,
                  optionLabel: `options["label"]`,
                  optionValue: 'id',
                  class: 'autocomplete',
                  value: info.empresa,
                  onChange: (e) => handleChange('empresa', e.id),
                },
                {
                  label: 'Orden comprobante',
                  name: 'orden',
                  sm: 12,
                  xs: 12,
                  class: 'textfield',
                  value: Math.max(0, parseInt(info.orden) || 1),
                  type: 'number',
                  onChange: (e) => handleChange('orden', e.target.value),
                },
                {
                  label: 'Monto',
                  name: 'subiva',
                  sm: 12,
                  xs: 12,
                  class: 'textfield',
                  value: Math.max(0, parseFloat(info.subiva)),
                  type: 'number',
                  inputProps: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <AttachMoney />
                      </InputAdornment>
                    ),
                  },
                  onChange: (e) => handleChange('subiva', e.target.value),
                },
                {
                  label: 'Observación',
                  name: 'observacion',
                  value: info.observacion,
                  sm: 12,
                  xs: 12,
                  class: 'textfield',
                  multiline: true,
                  rows: 2,
                  onChange: (e) => handleChange('observacion', e.target.value),
                },
              ]
            : info.tipo === 'BONIFICACION'
              ? [
                  {
                    label: 'Orden comprobante',
                    name: 'orden',
                    sm: 12,
                    xs: 12,
                    class: 'textfield',
                    value: Math.max(0, parseInt(info.orden) || 1),
                    type: 'number',
                    onChange: (e) => handleChange('orden', e.target.value),
                  },
                  {
                    label: 'Monto',
                    name: 'subiva',
                    sm: 12,
                    xs: 12,
                    class: 'textfield',
                    type: 'number',
                    value: Math.max(0, parseFloat(info.subiva)),
                    inputProps: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <AttachMoney />
                        </InputAdornment>
                      ),
                    },
                    onChange: (e) => handleChange('subiva', e.target.value),
                  },
                  {
                    label: 'Observación',
                    name: 'observacion',
                    value: info.observacion,
                    sm: 12,
                    xs: 12,
                    class: 'textfield',
                    multiline: true,
                    rows: 4,
                    onChange: (e) => handleChange('observacion', e.target.value),
                  },
                ]
              : info.tipo === 'RECARGO'
                ? [
                    {
                      label: 'Orden comprobante',
                      name: 'orden',
                      sm: 12,
                      xs: 12,
                      class: 'textfield',
                      value: Math.max(0, parseInt(info.orden) || 1),
                      type: 'number',
                      onChange: (e) => handleChange('orden', e.target.value),
                    },
                    {
                      label: 'Medio de pago',
                      name: 'medio_pago',
                      sm: 12,
                      xs: 12,
                      options: data.metodosPago,
                      optionLabel: `options["tipo"]`,
                      optionValue: 'tipo',
                      value: info.medio_pago,
                      class: 'autocomplete',
                      onChange: (e) => handleChange('medio_pago', e.tipo),
                    },
                    {
                      label: 'Submedio de pago',
                      name: `submedio_pago_${info.medio_pago}`,
                      sm: 12,
                      xs: 12,
                      options: tarjetasFiltradas,
                      optionLabel: `options["nombre"]`,
                      optionValue: 'nombre',
                      value: info.submedio_pago,
                      class: 'autocomplete',
                      disabled: !['TARJETA DÉBITO', 'TARJETA CRÉDITO'].includes(info.medio_pago),
                      onChange: (e) => handleChange('submedio_pago', e.nombre),
                    },
                    {
                      label: 'Porcentaje (%)',
                      name: 'porcentaje',
                      sm: 12,
                      xs: 12,
                      class: 'textfield',
                      value: Math.max(0, parseInt(info.porcentaje)),
                      type: 'number',
                      onChange: (e) => handleChange('porcentaje', e.target.value),
                    },
                    {
                      label: 'Monto',
                      name: 'subiva',
                      sm: 12,
                      xs: 12,
                      class: 'textfield',
                      type: 'number',
                      value: Math.max(0, parseFloat(info.subiva)),
                      inputProps: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoney />
                          </InputAdornment>
                        ),
                      },
                      onChange: (e) => handleChange('subiva', e.target.value),
                    },
                    {
                      label: 'Observación',
                      name: 'observacion',
                      value: info.observacion,
                      sm: 12,
                      xs: 12,
                      class: 'textfield',
                      multiline: true,
                      rows: 4,
                      onChange: (e) => handleChange('observacion', e.target.value),
                    },
                  ]
                : []),
  ]
}

export const FieldsEdit = (payment, handleChange) => {
  return [
    {
      label: 'Orden comprobante',
      class: 'textfield',
      value: '1',
      sm: 6,
      xs: 12,
      disabled: payment.producto === 'MOTOR COMPLETO',
    },
    {
      label: 'Codigo',
      class: 'textfield',
      value: payment.codigo,
      sm: 6,
      xs: 12,
      disabled: true,
    },
    {
      label: 'Descripción',
      class: 'textfield',
      value: payment.descripcion,
      sm: 12,
      xs: 12,
      disabled: true,
    },
    {
      label: 'Nº de V',
      class: 'textfield',
      value: payment.nrodev,
      sm: 6,
      xs: 12,
      disabled: true,
    },
    {
      label: 'Oblea',
      class: 'textfield',
      value: payment.oblea,
      sm: 6,
      xs: 12,
      disabled: true,
    },
    {
      label: 'Precio',
      class: 'textfield',
      value: payment.subiva ? payment.subiva.replace(/[^0-9.,]+/g, '') : '',
      sm: 12,
      xs: 12,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      onChange: (e) => handleChange('subiva', e.target.value),
    },
    {
      label: 'Observaciones',
      class: 'textfield',
      value: payment.observacion,
      sm: 12,
      xs: 12,
      multiline: true,
      rows: 2,
      onChange: (e) => handleChange('observacion', e.target.value),
    },
  ]
}

export const FieldsEditManual = (payment, handleChange) => {
  return [
    {
      label: 'Orden comprobante',
      class: 'textfield',
      type: 'number',
      value: Math.max(0, parseInt(payment.orden)),
      sm: 12,
      xs: 12,
      disabled: payment.producto === 'MOTOR COMPLETO',
      onChange: (e) => handleChange('orden', e.target.value),
    },
    {
      label: 'Descripción',
      class: 'textfield',
      value: payment.descripcion,
      sm: 12,
      xs: 12,
      disabled: true,
      onChange: (e) => handleChange('descripcion', e.target.value),
    },
    {
      label: 'Nº de V',
      class: 'textfield',
      value: payment.nrodev ? payment.nrodev : null,
      sm: 6,
      xs: 12,
      onChange: (e) => handleChange('nrodev', e.target.value),
    },
    {
      label: 'Cantidad',
      class: 'textfield',
      type: 'number',
      value: Math.max(0, parseInt(payment.cantidad) || 1),
      sm: 6,
      xs: 12,
      onChange: (e) => handleChange('cantidad', e.target.value),
    },
    {
      label: 'Precio',
      class: 'textfield',
      value: payment.subiva ? payment.subiva.replace(/[^0-9.,]+/g, '') : '',
      sm: 12,
      xs: 12,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      onChange: (e) => handleChange('subiva', e.target.value),
    },
    {
      label: 'Observaciones',
      class: 'textfield',
      value: payment.observacion,
      sm: 12,
      xs: 12,
      multiline: true,
      rows: 2,
      onChange: (e) => handleChange('observacion', e.target.value),
    },
  ]
}

export const FieldsEditMultiple = (payment, handleChange, data) => {
  const tarjetasFiltradas =
    payment.medio_pago === 'TARJETA DÉBITO'
      ? data.data.tarjetas.filter((tarjeta) => tarjeta.tipo === 1)
      : payment.medio_pago === 'TARJETA CRÉDITO'
        ? data.data.tarjetas.filter((tarjeta) => tarjeta.tipo === 2)
        : []

  return [
    {
      label: 'Orden comprobante',
      class: 'textfield',
      type: 'number',
      value: Math.max(0, parseInt(payment.orden)),
      sm: 12,
      xs: 12,
      onChange: (e) => handleChange('orden', e.target.value),
    },
    ...(payment.descripcion === 'ENVIO'
      ? [
          {
            label: 'Transporte',
            sm: 12,
            xs: 12,
            class: 'autocomplete',
            optionValue: 'id',
            options: data.data.transporte_retiro,
            optionLabel: `options["nombre"]`,
            value: payment.transporte,
            onChange: (e) => handleChange('transporte', e.id),
          },
          {
            label: 'Monto',
            sm: 12,
            xs: 12,
            class: 'textfield',
            type: 'number',
            value: payment.subiva ? payment.subiva.replace(/[^0-9.,]+/g, '') : '',
            inputProps: {
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoney />
                </InputAdornment>
              ),
            },
            onChange: (e) => handleChange('subiva', e.target.value),
          },
          {
            label: 'Observación',
            class: 'textfield',
            value: payment.observacion,
            sm: 12,
            xs: 12,
            multiline: true,
            rows: 4,
            onChange: (e) => handleChange('observacion', e.target.value),
          },
        ]
      : payment.descripcion === 'RESTO VENTA'
        ? [
            {
              label: 'Origen',
              name: 'empresa',
              sm: 12,
              xs: 12,
              options: SUCURSAL_ORIGEN,
              optionLabel: `options["label"]`,
              optionValue: 'id',
              class: 'autocomplete',
              value: payment.empresa,
              onChange: (e) => handleChange('empresa', e.id),
            },
            {
              label: 'Monto',
              sm: 12,
              xs: 12,
              class: 'textfield',
              type: 'number',
              value: payment.subiva ? payment.subiva.replace(/[^0-9.,]+/g, '') : '',
              inputProps: {
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachMoney />
                  </InputAdornment>
                ),
              },
              onChange: (e) => handleChange('subiva', e.target.value),
            },
            {
              label: 'Observación',
              class: 'textfield',
              value: payment.observacion,
              sm: 12,
              xs: 12,
              multiline: true,
              rows: 4,
              onChange: (e) => handleChange('observacion', e.target.value),
            },
          ]
        : payment.descripcion === 'BONIFICACION'
          ? [
              {
                label: 'Monto',
                sm: 12,
                xs: 12,
                class: 'textfield',
                type: 'number',
                value: payment.subiva ? payment.subiva.replace(/[^0-9.,]+/g, '') : '',
                inputProps: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <AttachMoney />
                    </InputAdornment>
                  ),
                },
                onChange: (e) => handleChange('subiva', e.target.value),
              },
              {
                label: 'Observación',
                class: 'textfield',
                value: payment.observacion,
                sm: 12,
                xs: 12,
                multiline: true,
                rows: 4,
                onChange: (e) => handleChange('observacion', e.target.value),
              },
            ]
          : payment.descripcion === 'RECARGO'
            ? [
                {
                  label: 'Medio de pago',
                  name: 'medio_pago',
                  sm: 12,
                  xs: 12,
                  options: data.data.metodosPago,
                  optionLabel: `options["tipo"]`,
                  optionValue: 'tipo',
                  value: payment.medio_pago,
                  class: 'autocomplete',
                  onChange: (e) => handleChange('medio_pago', e.tipo),
                },
                {
                  label: 'Submedio de pago',
                  name: `submedio_pago_${payment.medio_pago}`,
                  sm: 12,
                  xs: 12,
                  options: tarjetasFiltradas,
                  optionLabel: `options["nombre"]`,
                  optionValue: 'nombre',
                  value: payment.submedio_pago,
                  class: 'autocomplete',
                  disabled: !['TARJETA DÉBITO', 'TARJETA CRÉDITO'].includes(payment.medio_pago),
                  onChange: (e) => handleChange('submedio_pago', e.nombre),
                },
                {
                  label: 'Porcentaje (%)',
                  name: 'porcentaje',
                  sm: 12,
                  xs: 12,
                  class: 'textfield',
                  value: Math.max(0, parseInt(payment.porcentaje)),
                  type: 'number',
                  onChange: (e) => handleChange('porcentaje', e.target.value),
                },
                {
                  label: 'Monto',
                  sm: 12,
                  xs: 12,
                  class: 'textfield',
                  type: 'number',
                  value: payment.subiva ? payment.subiva.replace(/[^0-9.,]+/g, '') : '',
                  inputProps: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <AttachMoney />
                      </InputAdornment>
                    ),
                  },
                  onChange: (e) => handleChange('subiva', e.target.value),
                },
                {
                  label: 'Observación',
                  class: 'textfield',
                  value: payment.observacion,
                  sm: 12,
                  xs: 12,
                  multiline: true,
                  rows: 4,
                  onChange: (e) => handleChange('observacion', e.target.value),
                },
              ]
            : []),
  ]
}

export const FieldsEditResto = (payment, handleChange) => {
  return [
    {
      label: 'Origen',
      name: 'empresa',
      sm: 12,
      xs: 12,
      options: SUCURSAL_ORIGEN,
      optionLabel: `options["label"]`,
      optionValue: 'id',
      class: 'autocomplete',
      value: payment.empresa,
      onChange: (e) => handleChange('empresa', e.id),
    },
    {
      label: 'Orden comprobante',
      class: 'textfield',
      type: 'number',
      value: Math.max(0, parseInt(payment.orden)),
      sm: 12,
      xs: 12,
      onChange: (e) => handleChange('orden', e.target.value),
    },
    {
      label: 'Monto',
      class: 'textfield',
      value: payment.subiva ? payment.subiva.replace(/[^0-9.,]+/g, '') : '',
      sm: 12,
      xs: 12,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      onChange: (e) => handleChange('subiva', e.target.value),
    },
    {
      label: 'Observación',
      class: 'textfield',
      value: payment.observacion,
      sm: 12,
      xs: 12,
      multiline: true,
      rows: 4,
      onChange: (e) => handleChange('observacion', e.target.value),
    },
  ]
}
